/**
 * Tour API helpers — reads tour state from meta tags and
 * communicates with the backend to persist completions.
 */

export function getTourState() {
  const meta = document.querySelector('meta[name="tour-state"]');
  if (!meta) return {};
  try {
    return JSON.parse(meta.getAttribute('content'));
  } catch {
    return {};
  }
}

export function isJustSignedUp() {
  const meta = document.querySelector('meta[name="just-signed-up"]');
  return meta && meta.getAttribute('content') === 'true';
}

export function userHasNonprofit() {
  const meta = document.querySelector('meta[name="user-has-nonprofit"]');
  return meta && meta.getAttribute('content') === 'true';
}

/**
 * Returns the role the user picked in the welcome modal
 * ('shopper' | 'freelancer' | 'nonprofit'), or null if they
 * skipped or signed up before this code shipped.
 */
export function getOnboardingRole() {
  try {
    return localStorage.getItem('solvy_onboarding_role');
  } catch (e) {
    return null;
  }
}

export function getCSRFToken() {
  const meta = document.querySelector('meta[name="csrf-token"]');
  return meta ? meta.getAttribute('content') : '';
}

/**
 * Mark a tour as complete on the server.
 * Also updates the in-page meta tag so subsequent checks
 * within the same page load see the new state.
 */
export async function markTourComplete(tourKey) {
  const response = await fetch('/api/v1/tour_state', {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': getCSRFToken()
    },
    body: JSON.stringify({ tour_key: tourKey })
  });

  if (response.ok) {
    const data = await response.json();
    // Update the in-page meta tag
    const meta = document.querySelector('meta[name="tour-state"]');
    if (meta) {
      meta.setAttribute('content', JSON.stringify(data.tour_state));
    }
    return data.tour_state;
  }

  return null;
}
